import { NylasListThreadsRequestContent, NylasListThreadsResponseContent } from "@equaliq/api-model-v2";
import { createApiRequest } from "../common";

/**
 * API function to list threads with enriched metadata
 * @param request Thread list parameters (connectionId, filters, pagination)
 * @returns Promise with list of threads and pagination info
 */
export const listIntegrationThreadsApi = async (request: NylasListThreadsRequestContent): Promise<NylasListThreadsResponseContent> => {
  const apiRequest = createApiRequest<NylasListThreadsResponseContent>('post', '/integrations/nylas/threads/list');
  return apiRequest(request);
};
